import { graphql } from "../generated";

export const FeaturesFlags = graphql(`
  query FeaturesFlags {
    featureFlags
      @rest(type: "RestFeatureFlag", path: "feature_flags", endpoint: "v3") {
      advancedAiPackage
      dashboardExtensionEnableConversationsCenterCallScoring
      dashboardExtensionEnableRestrictedCompaniesAssetsPage
      disableFrontendTracking
      enableTrialAddonsForAdvancedMessaging
      enableTrialAddonsForAircallAi
      enableTrialAddonsForAircallSurveys
      enableTrialAddonsForAnalyticsPlus
      advancedAiPackageSentimentAnalysis
      conversationIntelligenceCustomerProvisioning
      conversationCenterDisableSentiments
      enableCustomInsights
    }
  }
`);
